export const ErrorEvent = {
    StringTableLoadFailure: 'StringTableLoadFailure'
};
